import styled from 'styled-components'

export const Wrapper = styled.div`
  .filter-search-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .content-wrapper {
    width: 400px;
    display: flex;
    flex-direction: column;
  }

  .p-multiselect {
    width: 50%;
  }

  .search-bar-wrapper {
    width: 50%;
  }
`
